module.exports = __webpack_public_path__ + "static/media/profile-pic.193da5a9.png";